import React, { FC } from 'react';
import classNames from 'classnames';
import ButtonCube from '#components/controls/buttons/buttonCube/ButtonCube';
import s from '#components/controls/buttons/favouriteButton/favouriteButton.module.scss';
import { useOvermindActions, useOvermindState } from '#store/overmind';
import useTranslation from 'next-translate/useTranslation';

type Props = {
  item?: { iri: string };
  isSizeSmall?: boolean;
  classes?: string;
};

const FavouriteButton: FC<Props> = ({ item, isSizeSmall, classes = '' }) => {
  const { t } = useTranslation();
  const { addFavourite, removeFavourite } = useOvermindActions().favourites;
  const { itemsIri } = useOvermindState().favourites;
  const isFavourite = itemsIri.indexOf(item.iri) !== -1;

  const extraClass = classNames({
    [s.isFavourite]: isFavourite,
    [s.isSizeSmall]: !!isSizeSmall,
  });

  const handleButtonClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    if (!item) {
      return;
    }

    if (isFavourite) {
      removeFavourite(item.iri);
    } else {
      addFavourite(item.iri);
    }
  };

  return (
    <ButtonCube
      dataTestId="favourites-button"
      text={t('addToFavourites')}
      extraClass={`${extraClass} ${classes}`}
      onClick={handleButtonClick}
      isSizeSmall={isSizeSmall}
    />
  );
};

export default FavouriteButton;
